import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type { RestigoSessionPushesPage } from 'shared-models/browser';

export type { RestigoSessionPushView, RestigoSessionPushesPage } from 'shared-models/browser';

class PosRestigoService {
  // Manager read of recent Restigo session pushes for the POS tenant (paginated).
  async listSessionPushes(
    tenantId: string,
    employeeSession: string,
    page = 1,
    pageSize = 20,
  ): Promise<RestigoSessionPushesPage> {
    try {
      const response = await authenticatedInstance.get<RestigoSessionPushesPage>(
        `/restigo/pos/tenant/${tenantId}/session-pushes`,
        { headers: { 'x-employee-session': employeeSession }, params: { page, pageSize } },
      );
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'טעינת שליחות רסטיגו נכשלה'));
    }
  }

  // Manager re-push of both reports for one closed session (idempotent aggregate resend).
  async resend(tenantId: string, employeeSession: string, sessionId: number): Promise<void> {
    try {
      await authenticatedInstance.post<void>(
        `/restigo/pos/tenant/${tenantId}/session/${sessionId}/resend`,
        undefined,
        { headers: { 'x-employee-session': employeeSession } },
      );
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, 'שליחה חוזרת לרסטיגו נכשלה'));
    }
  }
}

export const posRestigoService = new PosRestigoService();
